<template>
  <div class="index-module_articleWrap_2Zphx">
      <div  class="zhemo">文华财经小课堂 - 用<common-data name="appShortName_37"/>软件优化多因子量化策略</div>
        <p class="index-module_textWrap_3ygOc">通晓经济、金融、数学、计算机、心理、市场……才能做量化？开发量化策略需要复杂的编程，改个策略动辄需要重写几百行代码？写个因子需要捧起厚重的统计学教材？还得投入重金购买数据库和服务器？
        </p>
        <p class="index-module_textWrap_3ygOc">No，这些都可以不用！<common-data name="appShortName_37"/>率先推出了涵盖全流程的股票投资平台，利用平台自己写因子可以，自己不写因子也可以，利用平台丰富的因子库和研发工具包，同样也可以开发出量化策略，实现“有了<common-data name="appShortName_37"/>，自己做量化基金经理”的愿望！
        </p>
        <p class="index-module_textWrap_3ygOc">本期将介绍如何使用<common-data name="appShortName_37"/>软件全流程的策略研发平台，研发股票多因子量化策略。利用专业的策略研发工具包优化策略，提高策略整体收益。
        </p>
         <div class="info table2">
            <table cellpadding="7" cellspacing="0" style="width: 730px;background: #f7f9fc;text-indent:0">
                <tr class="center">
                    <th valign="top" width="18%">题目</th>
                    <th valign="top">内容</th>
                    <th valign="top" width="9%">讲师</th>
                </tr>
               <tr>
                    <td style="padding:0 5px;text-align:center;text-indent:0">全流程的策略研发平台</td>
                    <td>包括选股范围、添加因子、检验因子有效性、因子时效性参考、因子相关性分析、综合检验、持仓组合优化、大盘择时、个股择时、中性化处理、生成回测报告、最新调仓列表等多个步骤，囊括了多因子量化研究的全过程。</td>
                    <td rowspan="6"  style="padding:0 5px;text-align:center;text-indent:0">孙健</td>
                </tr>
                <tr>
                    <td style="padding:0 5px;text-align:center;text-indent:0">优选因子</td>
                    <td>采用分层回测的方式，验证因子有效性，配合因子时效性参考、因子相关性分析、综合检验等工具，筛选因子并确定因子权重分配方式，构建最优因子组合。</td>
                </tr>
                <tr>
                    <td style="padding:0 5px;text-align:center;text-indent:0">研发工具包1：<br>因子时效性参考</td>
                    <td>从动量、离散度、拥挤度三个维度考量大类因子有效性，预测因子当前的有效性周期，提供各大类因子的择时参考信息。</td>
                </tr>
                <tr>
                    <td style="padding:0 5px;text-align:center;text-indent:0">研发工具包2：<br>组合优化赋权</td>
                    <td>追求收益最大化的个股权重分配工具，可在一定约束条件下，以综合因子得分最大化为目标，自动构建最优持仓组合。</td>
                </tr>
                <tr>
                    <td style="padding:0 5px;text-align:center;text-indent:0">研发工具包3：<br>择时策略</td>
                    <td>大盘择时：根据大盘情况，以趋势择时策略，调节投资组合的仓位比例，降低回撤，提高收益。<br>个股择时：在轮动周期内添加禁止买入交易条件，实现多因子模型选股和个股择时的双重策略收益。</td>
                </tr>
                <tr>
                    <td style="padding:0 5px;text-align:center;text-indent:0">研发工具包4：<br>市场中性策略</td>
                    <td>满足机构使用股指期货构建市场中性策略的需求，且提供市值对冲、期货BETA对冲、市场性风险对冲三种对冲方式。</td>
                </tr>
            </table>
        </div>
        <div  class="index-module_textWrap_3ygOc">
                讲师介绍：
        </div>
        <!-- <div>【孙健】&nbsp;文华产品经理</div> -->
            <div  class="index-module_textWrap_3ygOc">
              【孙健】  &nbsp;文华财经大客户业务部产品经理，十年来专注于客户需求整理和产品设计，每年多次在全国范围内举办和参与期货和证券领域的大型授课活动，现主要负责服务机构客户，为专业的投资者提供技术支持，解决实际使用中的问题。
        </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.info,
.SignUp {
    color: #646464;
    line-height: 180%;
    padding: 0 0 3px 2em;
    font-size: 14px;
}
.info table{
    border: 1px solid #d1d7d7;
    border-collapse: collapse;
}

.info_2 {
    color: #646464;
    line-height: 180%;
    padding-bottom: 3px;
}

.info table {
    width: 688px;
}

.info th {
            padding: 5px 0;

    height: 24px;
    line-height: 24px;
    background: #a4bce2;
    color: #ffffff;
    border: 1px solid #d1d7d7;
    font-size: 14px;
    font-weight: normal;
    text-align: center;
}

.info td {
    padding: 0;
     padding: 5px 8px;

    border: 1px solid #d1d7d7;
    vertical-align: middle;
    padding-left: 8px;
}

.info td.time {
    color: #002c6f;
}

.td_w,.td_b{
    line-height: 29px;
    padding: 0 0 0 22px;
    font-size: 14px;
    color: #646567;
}

.td_b{
    background: #eef0fd;
}
.table2 tr td:first-child{
    text-align: left !important;
    padding-left: 10px !important;
}
</style>